import type { CurrentUser } from '@/services/types';

const IDENTITY_KEY = 'crm_list_cache_identity';
let authorizedToken: string | null = null;
let boundary: string | null = null;

/** Only business list caches are cleared; OAuth state and unrelated preferences survive. */
export function resetListCacheIdentity() {
  authorizedToken = null;
  boundary = null;
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith('mobile_') && key.includes('_list')) sessionStorage.removeItem(key);
    }
    sessionStorage.removeItem(IDENTITY_KEY);
  } catch { /* Optional storage may be disabled. */ }
}

/** Called only after the server has supplied the current authenticated identity. */
export function activateListCacheIdentity(user: CurrentUser) {
  const token = localStorage.getItem('token');
  if (!token || !user?.id || user.status === 0) {
    resetListCacheIdentity();
    return;
  }
  const identity = JSON.stringify([
    user.id, user.owningSupplierId, user.affiliationStatus, user.status, user.dataScope,
    [...(user.roles || [])].sort(), [...(user.permissions || [])].sort(),
  ]);
  try {
    const previous = JSON.parse(sessionStorage.getItem(IDENTITY_KEY) || 'null');
    if (previous?.identity !== identity || !previous?.generation) {
      resetListCacheIdentity();
      const generation = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(IDENTITY_KEY, JSON.stringify({ identity, generation }));
      boundary = generation;
    } else {
      boundary = previous.generation;
    }
    authorizedToken = token;
  } catch { resetListCacheIdentity(); }
}

export function getListCacheIdentity(): string | null {
  // A different tab may have replaced the shared token. Never reuse this tab's old identity.
  return authorizedToken && localStorage.getItem('token') === authorizedToken ? boundary : null;
}
